import * as React from 'react';
import { Stepper } from '../../ap/base/stepper';
import { route, navigateTo } from '../../links';

export enum VoiStep {
  Register,
  MobileVerification,
  ElectronicVerification,
  Payment,
}

export const VoiStepper = (props: { current: VoiStep }) => {
  const goBackToRegister =
    [VoiStep.Register, VoiStep.MobileVerification, VoiStep.ElectronicVerification].some(x => x === props.current)
      ? () => navigateTo(route.registerEdit(), true)
      : null;

  return <Stepper
    current={props.current}
    steps={[
      {
        text: "Input Details",
        onClick: goBackToRegister
      },
      {
        text: "Mobile Verification"
      },
      {
        text: "Electronic Verification"
      },
      {
        text: "Payment"
      }
    ]}
    />
}

export enum DocumentSightingStep {
  Register,
  MobileVerification,
  DocumentSighting,
  Payment,
}

export const DocumentSightingStepper = (props: { current: DocumentSightingStep }) => {
  const goBackToRegister =
    [DocumentSightingStep.Register, DocumentSightingStep.MobileVerification, DocumentSightingStep.DocumentSighting].some(x => x === props.current)
      ? () => navigateTo(route.registerEdit(), true)
      : null;

  return <Stepper
    current={props.current}
    steps={[
      {
        text: "Input Details",
        onClick: goBackToRegister
      },
      {
        text: "Mobile Verification"
      },
      {
        text: "Document Sighting"
      },
      {
        text: "Payment"
      }
    ]}
    />
}
